/**
 * 缓存第一次方法调用结果，避免相同时间调用多次
 * @template T
 * @param {T} fn, Function to be memorize.
 * @param {number} timeout, seconds until wait lock timeout, default 1 minutes.
 * @return {T}
 */
export function memorizeFn(fn, timeout = 60) {
  if (typeof fn !== "function") {
    throw new TypeError("Must pass a function as the function to be memoized");
  }

  let called;
  let memorizedReturn;
  const result_fn = function (...args) {
    const now = Date.now();
    if (called) {
      // 没超过时间则返回缓存的值
      if (now - called < timeout * 1000) {
        return memorizedReturn;
      }
    }
    called = now;
    memorizedReturn = fn.apply(this, args);
    return memorizedReturn;
  };

  return result_fn;
}
